import { Link } from "react-router-dom";
import { supportNumber } from "../../utils/supportNumber";

export const questions = [
  {
    title: "Quando meu acesso é liberado no Portal do Cliente?",
    answer:
      "Assim que a compra for faturada o seu acesso é liberado e você já pode realizar o primeiro acesso.",
  },
  {
    title: "Como realizo o primeiro acesso?",
    answer: (
      <p>
        Para realizar o primeiro login, entre no site do{" "}
        <Link to="/" target="_blank" rel="noreferrer">
          Portal do Cliente
        </Link>
        . No campo do login, digite o CPF ou CNPJ utilizado na compra e a sua
        senha de primeiro acesso será os 4 primeiros dígitos do CPF ou CNPJ que
        usou no momento da compra. Após entrar na plataforma, será solicitado
        que você troque a senha. Dessa forma seu acesso estará definido e será
        automático no próximo login. Com esse passo realizado você tem acesso a
        todo material presente no Portal do Cliente.
      </p>
    ),
  },
  {
    title: "Não consegui realizar o login, o que eu faço?",
    answer: (
      <p>
        Caso não consiga por favor clique em “Esqueci minha senha” e siga os
        passos informados. Se ainda tiver algum problema para acessar, entre em
        contato com nosso Suporte ao Cliente, pelo{" "}
        <a
          href={`https://api.whatsapp.com/send?phone=${supportNumber.whatsApp}&text=Ol%C3%A1,%20estou%20com%20problemas%20para%20acessar%20o%20Portal%20do%20Cliente.`}
          target="_blank"
          rel="noreferrer"
        >
          WhatsApp {supportNumber.phone}
        </a>
        , para verificar o que pode estar acontecendo.
      </p>
    ),
  },
  {
    title: "Para compras em grupo, com mais sócios, como funcionará o acesso?",
    answer:
      "Caso você tenha comprado a tecnologia em sociedade, basta entrar em contato com nosso Suporte ao Cliente e informar os seguintes dados: Nome, CPF, endereço completo, e-mail, telefone e o CNPJ da empresa em que você é sócio. A nossa equipe de relacionamento irá solicitar esse cadastro e liberar o seu acesso o quanto antes.",
  },
  {
    title: "Quais materiais encontro no Portal do Cliente?",
    answer:
      "Status do pedido, acesso aos boletos, status financeiro (parcelas pagas e parcelas em aberto), apoio Marketing (Biblioteca completa com o material de marketing das tecnologias adquiridas) e assuntos relacionados à assistência técnica.",
  },
  {
    title: "Esqueci a senha, como posso recuperá-la? ",
    answer:
      "A recuperação de senha é feita através do link “Esqueci a senha”, presente na home do Portal do Cliente, logo abaixo dos campos de login. Para recuperar o acesso, basta informar o CNPJ ou CPF que em seguida será enviado para o seu e-mail um link para redefinição da senha. Por isso, é importante que assim que o primeiro login for feito, os dados de acesso sejam conferidos, como e-mail de contato e telefone celular.",
  },
  {
    title:
      "Adquiri uma tecnologia com o Grupo Medsystems, mas os materiais relacionados não estão disponíveis no Apoio Marketing. Como posso resolver isso?",
    answer: (
      <p>
        Entre em contato diretamente com o nosso Suporte ao Cliente, através do{" "}
        <a
          href={`https://api.whatsapp.com/send?phone=${supportNumber.whatsApp}&text=Ol%C3%A1!%20Tudo%20bem%3F%20Gostaria%20de%20falar%20a%20respeito%20de%20uma%20d%C3%BAvida%2C%20sobre%20o%20Portal%20do%20Cliente%20da%20Medsystems!%20`}
          target="_blank"
          rel="noreferrer"
        >
          WhatsApp {supportNumber.phone}
        </a>
        , relatando o seu caso. A nossa equipe de relacionamento irá verificar
        as informações e te apoiar de maneira individual.
      </p>
    ),
  },
  {
    title:
      "Comprei uma tecnologia em um CPF e outra tecnologia em um CPNJ, como consigo acessar o portal?",
    answer: (
      <p>
        Caso você tenha realizado compras de tecnologias em diferentes CPF e
        CNPJ, entre em contato diretamente com o Suporte ao Cliente, pelo{" "}
        <a
          href={`https://api.whatsapp.com/send?phone=${supportNumber.whatsApp}&text=Ol%C3%A1!%20Tudo%20bem%3F%20Gostaria%20de%20falar%20a%20respeito%20de%20uma%20d%C3%BAvida%2C%20sobre%20o%20Portal%20do%20Cliente%20do%20Grupo%20Medsystems!%20`}
          target="_blank"
          rel="noreferrer"
        >
          WhatsApp {supportNumber.phone}
        </a>
        , relatando o seu caso. A nossa equipe de relacionamento irá verificar
        as informações e irá liberar um acesso unificado para você.
      </p>
    ),
  },
  {
    title: "Não estou encontrando o boleto da minha tecnologia, como proceder?",
    answer: (
      <p>
        Em caso de dúvidas sobre os boletos, status financeiro ou necessidade de
        boletos em outros bancos, você pode enviar um e-mail com sua solicitação
        para{" "}
        <a
          href="mailto:contas.receber@medsystems.com.br"
          target="_blank"
          rel="noreferrer"
        >
          contas.receber@medsystems.com.br
        </a>
      </p>
    ),
  },
];
